import CadastrarEditarTemplateHelpdesk from "./CadastrarEditarTemplate";

export default function ConfigurarTemplatesHelpdesk() {
    return (
        <div className="bg-white rounded p-2">
            <CadastrarEditarTemplateHelpdesk />
        </div>
    );
}
